import {useRef, useEffect, useState, useCallback} from 'react';
import { withTranslation } from 'react-i18next';
import imagesLoaded from 'imagesloaded';
import cx from 'classnames';
import { use100vh } from 'react-div-100vh';

import { useRecoilValue } from 'recoil';
import { isMobileAtom } from 'store/atoms';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import SkewGalleryItem from './SkewGalleryItem';
import styles from './SkewGallery.module.scss';

import Scroll from "assets/icons/scroll.svg";
import Hand from "assets/icons/hand.svg";

import UpArr from 'assets/icons/circularUpArr.svg';
import DownArr from 'assets/icons/circularDownArr.svg';

const SkewGallery = ({ children, t}) => {
	const componentWrap = useRef(null);
	const sliderWrap = useRef(null);
	const textBox = useRef(null);
	const contentIntro = useRef(null);
	const [winsize, setWinsize] = useState({
		width: window.innerWidth, height: window.innerHeight
	});
	const height = use100vh();
	const [contOffset, setContOffset] = useState(0);
	const [imgLoaded, setImgLoaded] = useState(false);
	const [animProg, setAnimProg] = useState(0);
	const [contentIndex, setContentIndex] = useState(0);
	const [contentAnimating, setContentAnimating] = useState(false);
	const preloadImages = () => {
      return new Promise((resolve, reject) => {
          imagesLoaded(
          	componentWrap.current.querySelectorAll(`.${styles.image}`), {background: true}, 
          	resolve
        	);
      });
  };
	const isMobile = useRecoilValue(isMobileAtom);

  // const changeTextBlock = (i) => {
  // 	const content = textBox.current.querySelectorAll(`.${styles.contentBlock}`);
  // 	const target = Math.abs(i - 1);
  // 	const height = textBox.current.offsetHeight;
  // 	content[i].style.display = null;
  // 	gsap.fromTo(textBox.current, {
  // 		height: height, duration: 0.2
  // 	}, {
  // 		height:content[i].offsetHeight
  // 	});
  // 	setContentAnimating(true);
  // 	setTimeout(() => {
  // 		setContentAnimating(false);
  // 		content[target].style.display = 'none';
  // 		textBox.current.style.height = null;
  // 	}, 300);
  // 	setContentIndex(i);
  // }

  // useEffect(() => {
  // 	if(animProg > 0.5 && contentIndex === 0){
  // 		changeTextBlock(1);
  // 	} else if(animProg < 0.5 && contentIndex === 1) {
  // 		changeTextBlock(0);
  // 	}
  // }, [animProg, contentIndex]);

	const calcWinsize = () => {
		const wrapper = componentWrap.current;
		if(wrapper){
			const imageConveyor = wrapper.querySelector(`.${styles.images}`);
			setWinsize({width: window.innerWidth, height: sliderWrap.current.offsetHeight});
			wrapper.style.setProperty(
				'--slider-transition-amount', 
				`${(imageConveyor.offsetHeight - sliderWrap.current.offsetHeight)}px`
			);
	  	setContOffset(imageConveyor.offsetHeight);
		}
	}

	const onResize = useCallback(() => {
		calcWinsize();
		ScrollTrigger.update();
	}, [])

	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger);

		const initializeGallery = () => {
			// ScrollTrigger.refresh();
			calcWinsize();

			const wrapper = componentWrap.current;

			setImgLoaded(true);
			
			gsap.timeline({
	  		scrollTrigger: {
		      trigger: wrapper,
		      pin: true,   // pin the trigger element while active
		      pinSpacing: false,
		      start: "top top", // when the top of the trigger hits the top of the viewport
		      end: `+=${componentWrap ? componentWrap.current.dataset.height : 0}px`, // end after scrolling 500px beyond the start
		      ease: "none",
		      scrub: 0.2,
			    onUpdate: self => {
			    	setAnimProg(self.progress);
			    	componentWrap.current.style.setProperty(
							'--slider-transition-progress', 
							self.progress
						);
			    }
		    }
		  });
		}

		gsap.to(contentIntro.current, {
			scrollTrigger: {
				trigger: contentIntro.current,
				start: 'bottom top',
				onToggle: (self) => {
					console.log('test');
					const targets = document.querySelectorAll(`.${styles.marquee}`);
					if(self.direction === -1){
						targets.forEach(target => target.style.display = 'block');
					} else {
						targets.forEach(target => target.style.display = 'none');
					}
				}
			}
		});

		const wrapper = componentWrap.current;
		if(wrapper){
			wrapper.style.setProperty(
				'--slider-transition-progress', 
				0
			);
			window.addEventListener('resize', onResize);
			preloadImages().then(initializeGallery);
		}
	}, [onResize]);

	const childProps = {
		progress: animProg,
		winsize,
		contHeight: contOffset,
		ready: imgLoaded
	}

	return (
		<>
			<div className={styles.wrap} style={{paddingBottom: (height * 0.5) * (children.length || 1)}}>
				<div ref={componentWrap} className={styles.pinWrap} data-height={(height * 0.5) * (children.length || 1)}>
					<div 
						className={styles.grid} 
					>
						<div className={styles.ui}>
							<h3>TOMMY X TIMBERLAND</h3>
							<div className={styles.progressIndicator}>
								<img src={UpArr} alt="" />
								<div className={styles.progressBar}>
									<span style={{
										height: `${(100 / children.length)}%`,
										top: `${(100 - (100 / children.length)) * animProg}%`
									}}/>
								</div>
								<img src={DownArr} alt="" />
							</div>
							<ul>
								{children.map((item, i) => 
									<li 
										key={`skewgall-indicator-${i}`}
										className={animProg >= (1 / children.length) * i && animProg < (1 / children.length) * (i+1) ? styles.active : ''}
									>{String(i+1).padStart(2, '0')}</li>
								)}
							</ul>
						</div>
						<div className={styles.sliderWrap} ref={sliderWrap}>
							<div className={styles.images}>
								{children && children.length > 1 ? <>
	              	<SkewGalleryItem 
		                zIndex={0}
		                dupe
		                {...childProps}
		              >
		                {children[children.length - 1]}
		              </SkewGalleryItem>
									{children.map(
										(item, i) => <SkewGalleryItem 
											key={`skewgallery-item-${i+1}`}
											debug={(i===children.length - -2)}
											zIndex={i}
											{...childProps}
										>
											{item}
										</SkewGalleryItem>
									)}
									<SkewGalleryItem 
										dupe
		                zIndex={children.length+1}
		                {...childProps}
		              >
		                {children[0]}
		              </SkewGalleryItem>
								</> : (
									<>
										<SkewGalleryItem {...childProps}>
										</SkewGalleryItem>
										<SkewGalleryItem {...childProps}>
											{children}
										</SkewGalleryItem>
										<SkewGalleryItem {...childProps}>
										</SkewGalleryItem>
									</>
								)}
							</div>
						</div>
						<div className={cx(styles.textBox, {[styles.animating]: contentAnimating})} ref={textBox}>
							<div className={styles.contentBlock} style={{opacity: contentIndex === 0 ? 1 : 0}}>
								<h3>{t('drop2-module-one-preheader')}</h3>
								<h1>{t('drop2-module-one-header')}</h1>
								<p>{isMobile ? t('drop2-module-one-sub1-mobile') : t('drop2-module-one-sub1')}</p>
							</div>
						</div>
					</div>
					<button className={styles.scrollPrompt} onClick={() => {
						gsap.to(window, {duration: 1, scrollTo: contentIntro.current});
						window.TTB?.onAnalyticsEvent("click_cta", "scroll_shopthecollection", "engagement");
					}}>
						<span>
							<img className={[styles.scrollIcon, styles.scrollDesktop].join(' ')} src={Scroll} alt="Scroll for more information" />
							<img className={[styles.scrollIcon, styles.scrollMobile].join(' ')} src={Hand} alt="Scroll for more information" />
							<p>{t('drop2-module-one-icon')}</p>
						</span>
					</button>
					<span className={styles.skewBg}/>
				</div>
			</div>
			<div ref={contentIntro}/>
		</>
	);
}

export default withTranslation()(SkewGallery);